import { motion } from "framer-motion";
import { ArrowRight, ShieldCheck, Clock3, Leaf } from "lucide-react";

export default function Hero() {
  const scrollTo = (id) => (e) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <section className="relative pt-28 md:pt-32 pb-20 md:pb-28 overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0 grain-bg" aria-hidden="true" />
      <div className="absolute inset-0 ripple-pattern opacity-40" aria-hidden="true" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 items-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-7"
        >
          <span className="inline-flex items-center gap-2 rounded-full border border-sky-200 bg-sky-50 px-3 py-1 text-xs font-bold uppercase tracking-[0.15em] text-sky-700">
            <span className="h-1.5 w-1.5 rounded-full bg-sky-600" /> Trusted Cleaning Experts
          </span>
          <h1 className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter text-slate-900 leading-[1.05]">
            Shine <span className="text-sky-600">like new.</span>
          </h1>
          <p className="mt-5 text-lg text-slate-600 max-w-xl leading-relaxed">
            Professional car, home and water tank cleaning — done by trained pros,
            on schedule, with eco-friendly products. Book in under 60 seconds.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#booking"
              onClick={scrollTo("booking")}
              className="btn-primary inline-flex items-center justify-center gap-2 rounded-full px-7 py-4 text-base font-semibold"
              data-testid="hero-cta-quote"
            >
              Get a Free Quote <ArrowRight className="h-4 w-4" />
            </a>
            <a
              href="#services"
              onClick={scrollTo("services")}
              className="inline-flex items-center justify-center gap-2 rounded-full border border-slate-200 bg-white px-7 py-4 text-base font-semibold text-slate-800 hover:border-sky-300 hover:text-sky-700 transition"
              data-testid="hero-cta-services"
            >
              Explore Services
            </a>
          </div>

          <div className="mt-10 flex flex-wrap gap-6 text-sm text-slate-600">
            <div className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-sky-600" /> 100% Satisfaction</div>
            <div className="flex items-center gap-2"><Leaf className="h-4 w-4 text-sky-600" /> Eco-friendly Products</div>
            <div className="flex items-center gap-2"><Clock3 className="h-4 w-4 text-sky-600" /> On-time, Every time</div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="lg:col-span-5 relative"
        >
          <div className="relative rounded-3xl overflow-hidden shadow-[0_30px_60px_rgba(2,132,199,0.18)] ring-1 ring-slate-200">
            <img
              src="https://images.pexels.com/photos/6196566/pexels-photo-6196566.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=800"
              alt="Pristine cleaning"
              className="w-full h-[460px] md:h-[540px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-sky-900/20 via-transparent to-white/10" />
          </div>

          <div className="hidden md:block absolute -left-8 bottom-10 bg-white rounded-2xl shadow-xl border border-slate-100 px-5 py-4 w-64">
            <p className="text-xs font-bold uppercase tracking-[0.15em] text-sky-600">Today</p>
            <p className="mt-1 font-display text-2xl font-bold text-slate-900">42 homes</p>
            <p className="text-xs text-slate-500">shining like new</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
